// THIS VALUES ARE USED DURING CLIENT APP COMPILATION, PLEASE DO NOT MOVE
const initialAppId = 'app_d1LaueEXmVjh7hN4g1ggHX'
const initialProjectId = 'proj_uaUyg4d3er9gTugaemM5in'
// eslint-disable-next-line import/newline-after-import, @typescript-eslint/no-var-requires
const initialBuildOrdersOnApp = require('./buildOrders.loaded.json')
const initialRunningMode = 'premium'
const initialCustomFontName = undefined
// #################

export const initialAppState = {
    appId: initialAppId,
    projectId: initialProjectId,
    buildOrders: initialBuildOrdersOnApp,
    runningMode: initialRunningMode,
    customFontName: initialCustomFontName,
} as const
